import request from '../../request';
import { tagServiceAPI } from './insightsUrls';

export class tagService {
  static getTags() {
    return request({
      url: tagServiceAPI.get,
      method: 'GET',
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static putTag(tag) {
    return request({
      url: tagServiceAPI.put,
      method: 'PUT',
      data: tag,
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static postTag(tag) {
    return request({
      url: tagServiceAPI.post,
      method: 'POST',
      data: tag,
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static deleteTag(tag) {
    return request({
      url: tagServiceAPI.delete(tag.id),
      method: 'DELETE',
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static mergeTag(data) {
    return request({
      url: tagServiceAPI.mergeTag,
      method: 'POST',
      data,
    })
      .then((response) => response)
      .catch((response) => response);
  }
}

export default tagService;
